/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotesModel } from '../../models/notes-model';
import { UpdateEncounterNotesModel } from '../../models/update-encounter-notes-model';

export interface EncounterUpdateNotesPost$Params {
      body?: UpdateEncounterNotesModel
}

export function encounterUpdateNotesPost(http: HttpClient, rootUrl: string, params?: EncounterUpdateNotesPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<NotesModel>> {
  const rb = new RequestBuilder(rootUrl, encounterUpdateNotesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<NotesModel>;
    })
  );
}

encounterUpdateNotesPost.PATH = '/Encounter/UpdateNotes';
